module.exports = __webpack_public_path__ + "static/media/logo-with-text-white.3b5c0d92.svg";